import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingDevis from "./components/FloatingDevis";
import Home from "./pages/Home";
import Particuliers from "./pages/Particuliers";
import Professionnels from "./pages/Professionnels";
import GardeMeubles from "./pages/GardeMeubles";
import LocationMateriel from "./pages/LocationMateriel";
import TransportObjet from "./pages/TransportObjet";
import Calculateur from "./pages/Calculateur";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/particuliers" element={<Particuliers />} />
            <Route path="/professionnels" element={<Professionnels />} />
            <Route path="/garde-meubles" element={<GardeMeubles />} />
            <Route path="/location-materiel" element={<LocationMateriel />} />
            <Route path="/transport-objet" element={<TransportObjet />} />
            <Route path="/calculateur" element={<Calculateur />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <FloatingDevis />
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
